import {defineStore} from 'pinia'
import {useModalsStore} from '@/stores/modals'

export const useLightboxStore = defineStore('lightbox', {
    state: () => ({
        items: []
    }),
    
    actions: {
        reset() {
            this.items = []
        },
        
        add(obj) {
            this.items.push(obj)
        },
        
        show(id) {
            const modalsStore = useModalsStore()
            
            modalsStore.show({
                componentName: 'LightboxModal',
                obj: {
                    items: this.items,
                    id
                }
            })
        }
    }
})